import { render, staticRenderFns } from "./SplitInformationLink.vue?vue&type=template&id=b2cd4a5a&scoped=true&"
import script from "./SplitInformationLink.vue?vue&type=script&lang=js&"
export * from "./SplitInformationLink.vue?vue&type=script&lang=js&"
import style0 from "./SplitInformationLink.vue?vue&type=style&index=0&id=b2cd4a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cd4a5a",
  null
  
)

export default component.exports